import { Card, CardContent, Stack, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

export default function AccessDenied() {
  return (
    <Card elevation={0}>
      <CardContent>
        <Stack alignItems='center' sx={{ paddingY: 4 }}>
          <LockOutlinedIcon sx={{ fontSize: 80 }} />
        </Stack>
        <Typography
          component='h1'
          variant='h5'
          sx={{ fontWeight: 600, textAlign: 'center', marginBottom: 1 }}
        >
          Käyttö rajoitettu
        </Typography>
        <Typography sx={{ textAlign: 'center' }}>
          Sinulla ei ole pääsyä tälle sivulle.
        </Typography>
      </CardContent>
    </Card>
  );
}
